export default __webpack_public_path__ + "static/DreamEnergy-abdf116dd7322c26fb76c3cc33a0c3e2.webp";